// Core
import React from "react";

const SectionHeading = (props) => {
    return (
        <section className = 'sectionHeading'>
            <h1>
                <span className = 'sectionNumber'>{props.number}</span>
                <span className = 'sectionName'>{props.title}</span>
            </h1>
        </section>
    );
};

export default SectionHeading;
